<template>
    <div class="row mb-3 latest-position">
        <div class="col-lg">
            <div class="row">
                <div class="form-group col-12 col-md-6 col-xl-4">
                    <label :for="'position-name-'+positionIndex">Functie</label>
                    <input v-validate="'required'"
                           :name="positionNameIndex('name')"
                           :id="'position-name-'+positionIndex"
                           type="text"
                           class="form-control"
                           v-model="positions.name">
                    <span v-if="errors.first(positionNameIndex('name'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-4">
                    <label :for="'position-employer-'+positionIndex">Werkgever</label>
                    <input v-validate="'required'"
                           :name="positionNameIndex('employer')"
                           :id="'position-employer-'+positionIndex"
                           type="text"
                           class="form-control"
                           v-model="positions.employer">
                    <span v-if="errors.first(positionNameIndex('employer'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-2">
                    <label for="position-start-date">Van</label>
                    <datepicker
                            :language="nl"
                            :id="'positionStartDate-'+positionIndex"
                            v-model="positions.startDate"
                            :fullMonthName="true"
                            format="dd-MM-yyyy"
                            input-class='form-control'
                            :calendar-button="true"
                            :calendar-button-icon="'far fa-calendar-alt'"
                            :clear-button="true"
                            :clear-button-icon="'far fa-times'"
                            :class="{ 'is-invalid': errors.has(positionNameIndex('fromDate')) }"
                    >
                    </datepicker>
                    <input v-model="positions.startDate" v-show="false" v-validate="'required'"
                           :name="positionNameIndex('fromDate')"/>
                    <span v-if="errors.first(positionNameIndex('fromDate'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-2">
                    <label for="position-end-date">Tot</label>
                    <datepicker
                            :language="nl"
                            :id="'positionEndDate'+positionIndex"
                            v-model="positions.endDate"
                            :fullMonthName="true"
                            format="dd-MM-yyyy"
                            input-class='form-control'
                            :calendar-button="true"
                            :calendar-button-icon="'far fa-calendar-alt'"
                            :clear-button="true"
                            :clear-button-icon="'far fa-times'"
                            :class="{ 'is-invalid': errors.has(positionNameIndex('fromDate')) }"
                    >
                    </datepicker>
                    <input v-model="positions.endDate" v-show="false" v-validate="'required'"
                           :name="positionNameIndex('endDate')"/>
                    <span v-if="errors.first(positionNameIndex('endDate'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-6">
                    <label :for="'position-activities-'+positionIndex">Werkzaamheden</label>
                    <textarea :name="positionNameIndex('activities')"
                              :id="'position-activities-'+positionIndex"
                              type="textarea"
                              class="form-control"
                              v-model="positions.activities"
                              v-validate="'required'"
                              rows="4"
                    ></textarea>
                    <span v-if="errors.first(positionNameIndex('activities'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
                <div class="form-group col-12 col-md-6">
                    <label :for="'position-reasonLeft-'+positionIndex">Reden vertrek</label>
                    <textarea :name="positionNameIndex('reasonLeft')"
                              :id="'position-reasonLeft-'+positionIndex"
                              class="form-control"
                              v-model="positions.reasonLeft"
                              v-validate="'required'"
                              rows="4"
                    ></textarea>
                    <span v-if="errors.first(positionNameIndex('reasonLeft'))" class="small text-danger">Dit veld is verplicht.</span>
                </div>
            </div>
        </div>
        <div class="col col-last-action repeat-row-actions">
            <template v-if="hideRowCheck">
                <i class="far fa-trash-alt" @click="removePositionRow(positionIndex)"></i>
            </template>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {nl} from 'vuejs-datepicker/dist/locale'

    export default {
        inject: ['$validator'],
        props: ['positions', 'positionIndex', 'renderedComponent'],
        components: {
            Datepicker
        },
        data() {
            return {
                nl: nl,
            }
        },
        methods: {
            removePositionRow(positionIndex) {
                this.$emit('positionRemoved', positionIndex)
            },
            positionNameIndex(name) {
                return name + this.positionIndex;
            },
        },
        computed: {
            hideRowCheck() {
                if (this.positionIndex === 0 || this.positionIndex === 1) {
                    return false;
                } else {
                    return true
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .latest-position {
        .col-lg,
        .col-last-action {
            border-bottom: 1px solid #ebebeb !important;
            margin-bottom: 15px;
        }

        &:last-child {
            .col-lg,
            .col-last-action {
                border-bottom: 0 !important;
                margin-bottom: 0;
            }
        }
    }

    .col-last-action {
        line-height: 235px;

        i:hover {
            cursor: pointer;
            color: #25b7bc;
        }
    }

    @media(max-width: 1199px) {
        .latest-position {
            .col-lg {
                margin-bottom: 0;
                border-bottom: 0 !important;
            }
            .col-last-action {
                padding-bottom: 15px;
                line-height: 30px;
                width: 100%;
                text-align: center;

                i:hover {
                    cursor: pointer;
                    color: #25b7bc;
                }
            }

            &:last-child {
                .col-last-action {
                    padding-bottom: 0;
                }
            }
        }
    }
</style>